import queries from '@apis/queries';
import Header from '@components/Header';
import useToast from '@hooks/ui/useToast';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Params {
    cardId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardChargeCompleteActivity: Params;
    }
}

const PrepaidCardChargeCompleteActivity: ActivityComponentType<'PrepaidCardChargeCompleteActivity'> = ({ params }) => {
    const { t } = useTranslation('prepaidCard');
    const { cardId } = params;
    const { replace, push } = useFlow();
    const toast = useToast();
    const queryClient = useQueryClient();
    useEffect(() => {
        if (cardId) {
            if (import.meta.env.MODE !== 'development') {
                console.log('prepaid charge complete');
            }
            queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def })
                .then(() => {
                    replace('MainActivity', {}, { animate: false });
                    push('MyPrepaidCardActivity', {});
                    toast.success(t('chargeComplete.success'));
                }).catch(() => {
                    replace('MainActivity', {}, { animate: false });
                    push('MyPrepaidCardActivity', {});
                    toast.error(t('chargeComplete.error'));
                });
        } else {
            toast.error(t('chargeComplete.failed'));
        }
    }, [cardId]);
    return (
        <AppScreen>
            <Header title={t('chargeComplete.title')} />
        </AppScreen>
    );
};

export default PrepaidCardChargeCompleteActivity;
